import dayjs from 'dayjs';
import { EmployeeType } from '../../../../../../store/api/employees-api';
import { ShiftType } from '../../../../../../store/api/shifts-api';

export type ShiftCellType = {
  employee: Pick<EmployeeType, 'id' | 'name' | 'surname' | 'tags'> & { shifts?: ShiftType[] };
  date: string;
  index?: number;
  onClick?: (
    dateShifts: ShiftType[],
    employee: Pick<EmployeeType, 'id' | 'name' | 'surname' | 'tags'>,
    date: string,
  ) => void;
  className?: string;
  status?: ShiftStatusType;
};

export type ShiftStatusType =
  | 'red-red'
  | 'green-green'
  | 'green-red'
  | 'red-green'
  | 'no-schedule'
  | 'absent'
  | 'planned';
// | 'day-off';

export const shiftStatusRecord: Record<ShiftStatusType, string> = {
  'red-red': 'Пришел с опозданием, ушел рано',
  'green-green': 'Пришел вовремя, ушел вовремя',
  'green-red': 'Пришел вовремя, ушел рано',
  'red-green': 'Опоздал, но переработал',
  'no-schedule': 'Отсутствует расписание',
  absent: 'Отсутствовал',
  planned: 'Запланировано',
  // 'day-off': 'Выходной',
};

export const getShiftStatus = (shift?: ShiftType): ShiftStatusType => {
  if (!shift) return 'no-schedule';
  const isPastShift = dayjs(shift.start_time).startOf('minute').isAfter(dayjs().startOf('minute'));

  if (isPastShift) {
    return 'planned';
  }

  // if (shift?.is_day_off) return 'day-off';
  if (!shift.start_time || !shift.end_time) return 'no-schedule';
  if (!shift.checkin) return 'absent';

  const startTime = dayjs(shift.start_time).startOf('minute');
  const endTime = dayjs(shift.end_time).startOf('minute');

  const startCheckin = dayjs(shift.checkin.start_time).startOf('minute');
  const endCheckin = dayjs(shift.checkin.end_time).startOf('minute');

  const isDelayedStart = startCheckin.isAfter(startTime);
  if (isDelayedStart) {
    const isDelayedEnd = endCheckin.isBefore(endTime);
    if (isDelayedEnd) {
      return 'red-red';
    }
    return 'red-green';
  }

  const isEarlyStart = startCheckin.isBefore(startTime) || startCheckin.isSame(startTime);
  if (isEarlyStart) {
    const isEarlyEnd = endCheckin.isAfter(endTime) || endCheckin.isSame(endTime);
    if (isEarlyEnd) {
      return 'green-green';
    }
    return 'green-red';
  }
  return 'no-schedule';
};

export const concatShifts = (shifts?: ShiftType[]): ShiftType | undefined => {
  if (!shifts?.length) {
    return undefined;
  }

  const concatedShift = shifts[0];

  const earliestStart = shifts.reduce((earliest, shift) => {
    const start = dayjs(shift.start_time);
    return start.isBefore(dayjs(earliest.start_time)) ? shift : earliest;
  });
  const latestEnd = shifts.reduce((latest, shift) => {
    const end = dayjs(shift.end_time);
    return end.isAfter(dayjs(latest.end_time)) ? shift : latest;
  });
  const earliestCheckin = shifts.reduce((earliest, shift) => {
    const checkinStart = dayjs(shift.checkin?.start_time);
    return checkinStart.isBefore(dayjs(earliest.checkin?.start_time)) ? shift : earliest;
  });

  const latestCheckin = shifts.reduce((latest, shift) => {
    const checkinEnd = dayjs(shift.checkin?.end_time);
    return checkinEnd.isAfter(dayjs(latest.checkin?.end_time)) ? shift : latest;
  });

  concatedShift.start_time = earliestStart.start_time;
  concatedShift.end_time = latestEnd.end_time;

  if (earliestCheckin.checkin || latestCheckin.checkin) {
    const checkin = (earliestCheckin.checkin || latestCheckin.checkin)!;
    concatedShift.checkin = {
      ...checkin,
      end_time: latestCheckin.checkin?.end_time || null,
      start_time: earliestCheckin.checkin?.start_time || null,
      shift: null,
    };
  }

  return concatedShift;
};
